import { environmentIdsSearchSchema } from '@routes/-environmentIdsSearch'
import { protectWithWorkspacePermissions } from '@routes/-protectWithPermission'
import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { AppRoute } from 'appRoutes'
import { VisitorDetailsPage } from 'features/visitorDetails'
import { getLDFlag } from 'helpers/launchDarkly'
import { canViewAnalyticsPermission } from 'hooks/usePermission'

export const Route = createFileRoute('/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId')({
  component: VisitorDetailsPage,
  head: () => ({
    meta: [{ title: withCompanyName('Visitor Details') }],
  }),
  validateSearch: environmentIdsSearchSchema,
  beforeLoad: async (ctx) => {
    const { params, context } = ctx

    const flagEnabled = getLDFlag('dashboard.visitor-details.enabled', false, context.ldClient)
    if (!flagEnabled) {
      throw redirect({ to: AppRoute.SubscriptionOverview, params: { subscriptionId: params.subscriptionId } })
    }

    await protectWithWorkspacePermissions(canViewAnalyticsPermission)(ctx)
  },
})
